import { useEffect, useState } from 'react';
import api from '../config/api';

export default function useUsernameAvailability(username) {
  const [result, setResult] = useState({ username: '', status: 'idle' });
  const [attempt, setAttempt] = useState(0);
  const value = username.trim();

  useEffect(() => {
    if (value.length < 3) {
      setResult({ username: value, status: 'idle' });
      return;
    }
    setResult({ username: value, status: 'checking' });
    let active = true;
    const controller = new AbortController();
    const timer = setTimeout(async () => {
      setResult({ username: value, status: 'checking' });
      try {
        const token = sessionStorage.getItem('pendingAuthToken') || localStorage.getItem('authToken');
        const response = await api.get('/users/check-username', {
          params: { username: value },
          signal: controller.signal,
          ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {}),
        });
        const data = response.data?.data ?? response.data;
        const available = data?.available ?? data?.is_available;
        if (typeof available !== 'boolean') throw new Error('Unexpected availability response');
        if (active) setResult({ username: value, status: available ? 'available' : 'unavailable' });
      } catch (error) {
        if (active) setResult({ username: value, status: error.response?.status === 409 ? 'unavailable' : 'error' });
      }
    }, 400);
    return () => { active = false; clearTimeout(timer); controller.abort(); };
  }, [value, attempt]);

  return {
    status: value.length < 3 ? 'idle' : result.username === value ? result.status : 'checking',
    retry: () => {
      setResult({ username: value, status: 'checking' });
      setAttempt((current) => current + 1);
    },
  };
}
